"use client";

import React from "react";
import { Zap, MessageSquare, TrendingUp } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
const engineFeatures = [{
  title: "Rapid Land Clearing",
  description: "Our high-performance mulchers turn dense brush and trees into nutrient-rich mulch in a fraction of the time of traditional methods.",
  icon: Zap
}, {
  title: "Eco-Friendly Process",
  description: "Low-impact machinery preserves your topsoil and root systems while eliminating the need for messy burn piles or costly hauling.",
  icon: MessageSquare
}, {
  title: "Maximum Property Value",
  description: "Instantly improve curb appeal and usable acreage, transforming overgrown lots into pristine, park-like landscapes ready for use.",
  icon: TrendingUp
}];
export default function TheViralityEngine() {
  return <section data-section-id="224052" id="why-were-different" className="bg-background text-foreground py-24 px-4 md:px-8 relative overflow-hidden">
      {}
      <style>{`
        @keyframes wood-float {
          0% { transform: translateY(0); }
          50% { transform: translateY(-5px); }
          100% { transform: translateY(0); }
        }
        .group:hover .animate-glitch {
          animation: wood-float 0.6s ease-in-out infinite;
        }
      `}</style>

      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-default font-bold tracking-tight mb-4 text-secondary">
            Why We're Different
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto font-default text-lg">
            Chipper Mulching Co. brings a playful spirit and professional power to every lot, ensuring your land is cleared with precision and care.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {engineFeatures.map((feature, i) => <div data-index={i} key={i} className="group relative h-full">
              {}
              <Card className="h-full bg-card/50 backdrop-blur-sm border-border transition-all duration-500 ease-out group-hover:-translate-y-2 group-hover:bg-white group-hover:border-primary/30 relative overflow-hidden rounded-2xl shadow-md">
                
                {}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-primary opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                
                {}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />

                <CardHeader className="pt-8 pb-4 relative z-10">
                  <div className="mb-6 inline-flex items-center justify-center w-20 h-20 rounded-lg bg-secondary/10 border border-secondary/20 shadow-sm">
                    <feature.icon className="w-10 h-10 text-secondary drop-shadow-sm animate-glitch transition-transform" />
                  </div>
                  <CardTitle className="text-2xl font-bold font-default tracking-wide text-secondary">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                
                <CardContent className="pb-8 relative z-10">
                  <CardDescription className="text-muted-foreground font-default text-base leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}